//Get the distance from an element to the top of the document
export const getOffsetTop = function (elem) {
	// Set our distance placeholder
	var distance = 0;

	// Loop up the DOM
	if (elem.offsetParent) {
		do {
			distance += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}

	// Return our distance
	return distance < 0 ? 0 : distance;
};

export const isWoocommerceUrl = (url = '') => {
	const urlHasSubstring = (substring) => url.indexOf(substring) > -1;
	const substrings = ['/checkout', '/cart', '/product/', 'gifts/account'];
	return substrings.some(urlHasSubstring);
};

export const isAdminUrl = (url = '') => {
	const urlHasSubstring = (substring) => url.indexOf(substring) > -1;
	const substrings = ['/wp-admin'];
	return substrings.some(urlHasSubstring);
};


//Set, get & delete cookies
export const setCookie = (name,value,days) => {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export const  getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
export const  eraseCookie = (name) => {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// Round distance to nearest mile
export const roundDistance = (distance) => {
	// Convert meters to miles
	distance = distance * 0.000621371;

	// Return distance to the closest 0.1 mile
	return Math.round(distance * 10) / 10;
}

export const getVideoFormat = (url) => {
	console.log(url);

	// Define the supported video formats
	const supportedFormats = ['.mp4', '.webm', '.ogg'];
	
	// Use a regular expression to extract the file extension
	const regex = /\.([0-9a-z]+)(?:[\?#]|$)/i;
	const match = url.match(regex);
	
	// Check if the file extension is one of the supported formats
	if (match && supportedFormats.includes(`.${match[1].toLowerCase()}`)) {
	  	return `.${match[1].toLowerCase()}`;
	} else {
	  	return null; // or you could return 'unsupported format' or any other appropriate value
	}
}

export const videoPlayer = (video) => {
	const videoContainer = video.closest('.js-video-popup-container');
	const videoTimeElapsed = videoContainer.querySelector('.js-video-popup-time-elapsed');
	const playPauseTrigger = videoContainer.querySelector('.js-video-popup-play-pause-trigger');
	const playPauseTriggerText = playPauseTrigger.querySelector('.js-video-popup-play-pause-trigger-text');
	const playIcon = playPauseTrigger.querySelector('.js-video-popup-play-icon');
	const pauseIcon = playPauseTrigger.querySelector('.js-video-popup-pause-icon');		
	const muteTrigger = videoContainer.querySelector('.js-video-popup-mute-trigger');
	const progressContainer = videoContainer.querySelector('.popup__video-progress-container');	
	const progressIndicators = progressContainer.querySelectorAll('.popup__video-progress-indicator');

	// Pause the video
	pauseVideo(video, playPauseTrigger);

	// Mute the video
	muteVideo(video, muteTrigger);

	// Update the progress bar
	updateProgress();

	// Play/Pause the video
	playPauseTrigger.addEventListener('click', (e) => {
		e.preventDefault();

		if ( video.paused ) {
			playVideo(video, playPauseTrigger);
		} else {
			pauseVideo(video, playPauseTrigger);
		}
	});

	video.addEventListener('click', (e) => {
		e.preventDefault();

		if ( video.paused ) {
			playVideo(video, playPauseTrigger);
		} else {
			pauseVideo(video, playPauseTrigger);
		}
	});

	// Mute/Unmute the video
	muteTrigger.addEventListener('click', (e) => {
		e.preventDefault();

		if ( video.muted ) {
			unmuteVideo(video, muteTrigger);
		} else {
			muteVideo(video, muteTrigger);
		}
	});

	// Reset the playPauseTrigger elems when the video ends
	video.addEventListener('ended', () => {
		pauseVideo(video, playPauseTrigger);
	});

	// Update the time elapsed text and the progress bar when the time updates
	video.addEventListener('timeupdate', () => {
		// Update the time elapsed text
		const timeElapsed = Math.floor(video.currentTime);
		const hours = Math.floor(timeElapsed / 3600);
		const minutes = Math.floor(timeElapsed / 60);
		const seconds = timeElapsed - minutes * 60;

		if (hours > 0) {
			videoTimeElapsed.textContent = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
		} else {
			videoTimeElapsed.textContent = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
		}

		// Update the progress bar
		updateProgress();
	});

	// Update the progress bar when the progress container is clicked
	progressContainer.addEventListener('click', setProgress);
	
	function playVideo() {
		// Play the video
		video.play();
		
		// Update the play/pause button text to 'Pause'
		playPauseTriggerText.textContent = 'Pause';
	
		// Hide the play icon and show the pause icon
		playIcon.classList.add('hidden');
		pauseIcon.classList.remove('hidden');
	
		// Add playing class to the play pause trigger
		playPauseTrigger.classList.add('playing');
	}
	
	function pauseVideo(video, playPauseTrigger) {
		// Pause the video
		video.pause();
	
		// Update the play/pause button text to 'Play'
		playPauseTriggerText.textContent = 'Play';
	
		// Hide the pause icon and show the play icon
		pauseIcon.classList.add('hidden');
		playIcon.classList.remove('hidden');
	
		// Remove playing class from the play pause trigger
		playPauseTrigger.classList.remove('playing');
	}

	function muteVideo(video, muteTrigger) {
		// Mute the video
		video.muted = true;

		// Update the mute button text to 'Sound On'
		muteTrigger.textContent = 'Sound On';

		// Remove muted class from the mute
		muteTrigger.classList.remove('muted');
	}
	
	function unmuteVideo(video, muteTrigger) {
		// Unmute the video
		video.muted = false;
	
		// Update the mute button text to 'Sound Off'
		muteTrigger.textContent = 'Sound Off';
	
		// Add muted class to the mute
		muteTrigger.classList.add('muted');
	}

	function updateProgress() {
		const { currentTime, duration } = video;
		const progressPercent = Math.floor((currentTime / duration) * 100);
		//console.log('progressPercent: ', progressPercent);

		// Get an array of all the visible progress indicators
		const visibleIndicators = Array.from(progressIndicators).filter(s =>
			window.getComputedStyle(s).getPropertyValue('display') != 'none'
		);

		// Calculate how many should be visible based on the progress percent
		const visibleIndicatorsCount = Math.floor((progressPercent / 100) * visibleIndicators.length);

		// Loop through all the visible progress indicators and update their classes based on the progress percent
		visibleIndicators.forEach((progressIndicator, index) => {
			if (index < visibleIndicatorsCount) {
				progressIndicator.classList.remove('bg-white/30');
				progressIndicator.classList.add('bg-white');
			} else {
				progressIndicator.classList.remove('bg-white');
				progressIndicator.classList.add('bg-white/30');
			}
		});
	}
	
	function setProgress(e) {
		const width = progressContainer.clientWidth;
		const clickX = e.offsetX;
		const duration = video.duration;
	
		video.currentTime = (clickX / width) * duration;
	}	
}

export const postRequest = async function (data) {
    const response = await fetch(igniteJsVars.ajaxurl, {
        method: "POST",
        body: data
    });

    if (!response.ok) {
        throw new Error(`[${response.status}] ${response.statusText}`);
    }

    const responseJson = await response.json();

    return responseJson;
}